import '../styles/index.scss';

import 'intersection-observer';
import 'core-js/modules/es.math.log2';
import * as Stickyfill from 'stickyfilljs';

import * as lazyload from './components/lazyload';
import * as marginals from './components/marginals';
import * as navigation from './components/navigation';
import * as analytics from './components/analytics/analytics';
import * as scrolly from './custom/scrolly';

import * as dotMap from './custom/map/map';
import Calendar from './custom/calendar/calendar';

import * as lookup from './custom/lookup';

let scroller, calendar, map, choose;

window.addEventListener('load', init);

function init() {
  Stickyfill
    .add(document.querySelectorAll('.sticky'));

  lazyload
    .init('.lazyload', {
      rootMargin: '300px 0px 300px 0px',
      threshold: 0
    })
    .observe();

  navigation.init();
  marginals.init();

  loadMapData().then(({ default: mapData }) => {
    map = dotMap.init({
      target: '#map',
      data: mapData
    });

    map.draw();

    scroller = scrolly.init({
      target: '.scrolly .step-content',
      map: map
    });

    loadCalenderData().then(({ default: calendarData }) => {
      choose = lookup.init({
        id: 'lookup',
        data: mapData
      });

      calendar = new Calendar({
        target: '#calendar',
        data: { calendar: Array(365).fill(0) }
      });

      calendar.draw();

      choose.input.addEventListener('awesomplete-select', function (event) {
        const textValue = event.text.value;
        let elevatorData = mapData.find(el => (el.station + ' ' + el.description) === textValue);

        // end text input
        choose.input.blur();

        // merge elevatorData with calendar
        elevatorData = Object.assign(
          {},
          elevatorData,
          calendarData.find(el => el.equipmentnumber === elevatorData.equipmentnumber)
        );

        // add vertical offset for better visibility
        elevatorData.lat = elevatorData.lat + 0.0005;

        map.update(elevatorData);

        // make section with calendar visible
        document.getElementById('exampleText').classList.remove('hidden');

        calendar.set({data: elevatorData});
        calendar.draw();

        // update text
        document.getElementById('station').textContent = elevatorData.station;
        document.getElementById('description').textContent = elevatorData.description;
        document.getElementById('days').textContent = elevatorData.calendar.filter(v => v > 0).length;
      });
    });
  });

  analytics.init({
    serviceUrl: 'https://ddj.br.de/analytics/track',
    projectId: 'aufzuege',
    tracker: {
      client: true,
      click: true,
      observer: true,
      timer: true,
      custom: true
    },
    respectDoNotTrack: false,
    debug: false
  });

  setViewport();
  addResizeHandler();
}

async function loadMapData() {
  return await import(/* webpackChunkName: "map-data" */ './custom/map/map-data.json');
}

async function loadCalenderData() {
  return await import(/* webpackChunkName: "calendar-data" */ './custom/calendar/calendar-data.json');
}

function setViewport() {
  document
    .querySelector('meta[name=viewport]')
    .setAttribute(
      'content',
      `width=${window.innerWidth}, height=${window.innerHeight}, initial-scale=1`
    );
}

function addResizeHandler() {
  let timeout;

  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      marginals.update();
      scroller.resize();
      map.update();
      calendar.update();
    }, 200);
  });
}
